import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  isPicked: false,
  isPickedByDoubleClickInGridRow: false,
  data: null,
};

const zmluva = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_ZMLUVA_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_ZMLUVA_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };

    case actionTypes.GET_ZMLUVA_FAILURE:
      return _initState;

    case actionTypes.CHANGE_ZMLUVA:
      const { data, isPickedByDoubleClickInGridRow } = action;
      return {
        ...state,
        data,
        isLoading: false,
        isPickedByDoubleClickInGridRow,
        isPicked: data.I_ZMLUVY !== null,
      };

    default:
      return state;
  }
};

export default zmluva;
